import { useTranslation } from 'react-i18next';
import { retailPainPoints } from '@/mocks/corporateRetailData';

function renderParagraphs(text: string, className: string) {
  return text.split(/(?:\r?\n){2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function PainPoints() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('corporateRetail.pain.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateRetail.pain.title')}
          </h2>
          {String(t('corporateRetail.pain.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {renderParagraphs(
            t('corporateRetail.pain.lead'),
            "text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto",
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {retailPainPoints.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-5 bg-background-100/60 border border-background-200/60"
            >
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-accent-500 text-lg`}></i>
              </div>
              {renderParagraphs(
                t(`corporateRetail.pain.${idx}`),
                "text-[16px] text-foreground-800 tracking-[0.04em] leading-relaxed pt-0.5",
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
